var map = {
	"./10_nuts.png": 2506,
	"./1drink_12beer.png": 2507,
	"./1serving_8ounces.png": 2508,
	"./1serving_8ounces2.png": 2509,
	"./1serving_8ounces3.png": 2510,
	"./1serving_8ounces4.png": 2511,
	"./1serving_8ounces5.png": 2512,
	"./8ounces_1glass.png": 2513,
	"./can_1.png": 2514,
	"./can_2.png": 2515,
	"./can_3.png": 2516,
	"./cup.png": 2517,
	"./dried_serving_1/4cup.png": 2518,
	"./dried_serving_1:4cup.png": 2519,
	"./fresh_serving_1cup.png": 2520,
	"./glass_1.png": 2521,
	"./glass_2.png": 2522,
	"./golfball.png": 2523,
	"./halfthumb.png": 2524,
	"./hand_1.png": 2525,
	"./hand_2.png": 2526,
	"./hand_3.png": 2527,
	"./hand_4.png": 2528,
	"./hand_5.png": 2529,
	"./how.png": 864,
	"./serving_1/2cup.png": 2530,
	"./serving_1:2cup.png": 2531,
	"./serving_1tbsp.png": 2532,
	"./serving_3/4ounces.png": 2533,
	"./serving_3:4ounces.png": 2534,
	"./thumbx2.png": 2535,
	"./usda.png": 2536,
	"./vegetables_1cup.png": 2537,
	"./what.png": 862,
	"./wholethumb.png": 2538,
	"./why.png": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2505;